export const GET_COUNTIES = 'get_counties';
export const GET_STATES = 'get_states';
export const GET_PHYSICIANS = 'get_physicians';
export const GET_PROFESSIONS = 'get_professions';

export interface Lookup {
  id: number,
  name: string
}
